import {
  Box,
  Button,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  Alert,
} from "@mui/material";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { setToken } from "../utils/auth";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Divider from "@mui/material/Divider";

const LogIn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from?.pathname || "/";

  const [form, setForm] = React.useState({ email: "", password: "" });
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post("/auth/token", {
        email: form.email,
        password: form.password,
      });
      setToken(res.data.access_token);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box
      sx={{
        mx: "auto",
        mt: 20,
        display: "flex",
        flexDirection: "row",
        borderRadius: 4,
        border: "2px solid #16a4b0",
        overflow: "hidden",
        width: { xs: "90%", sm: "70%" },
        minHeight: "60vh",
      }}
    >
      {/* Left section */}
      <Box
        sx={{
          flex: 1,
          backgroundColor: "#16a4b0",
          color: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="h3" fontWeight={700} mb={3}>
          Easy AI for Industry
        </Typography>
        <Typography variant="h6" sx={{ maxWidth: "80%", textAlign: "center" }}>
          Introducing EARN, the user-friendly application that simplifies AI for
          industries. With its intuitive interface and extensive library of
          pre-built models, EARN empowers businesses to effortlessly harness the
          power of AI.
        </Typography>
      </Box>

      {/* Right section */}
      <Box
        component="form"
        onSubmit={onSubmit}
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          p: 4,
        }}
      >
        <Typography variant="h4" fontWeight={700} color="black" mb={4}>
          Log In
        </Typography>

        <Box
          sx={{
            width: "80%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {error && <Alert severity="error">{error}</Alert>}

          <Typography variant="h7" color="black" textAlign="left">
            Email Address
          </Typography>
          <TextField
            label="Enter your email address"
            name="email"
            value={form.email}
            onChange={onChange}
            fullWidth
            autoComplete="off"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                "&:hover fieldset": { borderColor: "#00707c" },
                "&.Mui-focused fieldset": { borderColor: "#16a4b0" },
              },
            }}
          />

          <Typography variant="h7" color="black" textAlign="left">
            Password
          </Typography>
          <TextField
            label="Enter your password"
            type="password"
            name="password"
            value={form.password}
            onChange={onChange}
            fullWidth
            autoComplete="off"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                "&:hover fieldset": { borderColor: "#00707c" },
                "&.Mui-focused fieldset": { borderColor: "#16a4b0" },
              },
            }}
          />

          {/* Remember me + Forgot password */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              control={<Checkbox sx={{ color: "#16a4b0" }} />}
              label="Remember me"
            />
            {/* <Button
              type="button"
              variant="text"
              sx={{ textTransform: 'none', color: '#00707c', fontSize: '0.9rem', minWidth: 'auto', p: 0 }}
            >
              Forgot password?
            </Button> */}
          </Box>
        </Box>

        <Button
          type="submit"
          disabled={loading || !form.email || !form.password}
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          sx={{
            mt: 3,
            borderRadius: "12px",
            backgroundColor: "#16a4b0",
            color: "white",
            textTransform: "none",
            fontSize: "16px",
            width: "140px",
            "&:hover": { backgroundColor: "#00707c" },
          }}
        >
          {loading ? "Logging in…" : "Login"}
        </Button>

        <Box
          sx={{
            mt: 4,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography color="text.secondary">
            Don't have an account yet?
          </Typography>

          <Button
            variant="text"
            onClick={() => navigate("/new-user")}
            sx={{
              textTransform: "none",
              color: "#16a4b0",
              fontWeight: 600,
              fontSize: "1rem",
              minWidth: "auto",
              p: 0,
              "&:hover": {
                backgroundColor: "transparent",
                color: "#00707c",
              },
            }}
          >
            Sign up here
          </Button>
        </Box>

        <Box sx={{ width: "80%", mt: 4 }}>
          <Divider>OR</Divider>
        </Box>

        <Box
          sx={{
            mt: 3,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography color="text.secondary">Or</Typography>

          <Button
            variant="text"
            sx={{
              textTransform: "none",
              color: "#16a4b0",
              fontWeight: 600,
              fontSize: "1rem",
              minWidth: "auto",
              p: 0,
              "&:hover": {
                backgroundColor: "transparent",
                color: "#00707c",
              },
            }}
            onClick={async () => {
              setLoading(true);
              setError("");
              try {
                const res = await axios.post("/auth/token", {
                  email: "earn_guest@flandersmake.be",
                  password: "V!sionGu3st!",
                });
                setToken(res.data.access_token);
                navigate("/landing-page", { replace: true });
              } catch (err) {
                setError(
                  err.response?.data?.detail ||
                    err.message ||
                    "Guest login failed",
                );
              } finally {
                setLoading(false);
              }
            }}
          >
            Continue as a guest
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default LogIn;
